// Types
import { EquipmentUnitDataConeCrusher } from '../../../../../../../../types/crusher';
import { EdgeDeviceOperationalStatus } from '../../../../../../../../types/global';

export enum SensorThresholds {
  clampPressure = 'clampPressure',
  lubricationReturnTemp = 'lubricationReturnTemp',
  lubricationSupplyTemperature = 'lubricationSupplyTemperature',
  lubricationTankTemperature = 'lubricationTankTemperature',
  trampPressure = 'trampPressure',
}

export type SensorData = {
  key: string;
  name: string;
  value: React.ReactNode;
};

export type SensorImages = {
  hydraulicLevel: string;
  hydraulicTemperature: string;
  clampPressure: string;
  trampPressure: string;
  lubricationLevel: string;
  lubricationReturnTemp: string;
  lubricationTankTemperature: string;
  lubricationSupplyTemperature: string;
  linerContact: string;
  filterDirty: string;
};

export interface SensorsProps {
  className?: string;
  unitData: EquipmentUnitDataConeCrusher | null;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  testId?: string;
}
